module.exports = __webpack_public_path__ + "static/media/screenshot(6).799c880f.jpg";